module.exports = __webpack_public_path__ + "media/guide.808c4455.mp4";